import { AsyncPipe, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { CmsComponent, TranslatePipe } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

export interface CmsShimanoTimestampedComponent extends CmsComponent {
  title?: string;
}

@Component({
  selector: 'app-shimano-timestamped',
  templateUrl: './shimano-timestamped.component.html',
  styleUrls: ['./shimano-timestamped.component.scss'],
  imports: [AsyncPipe, DatePipe, TranslatePipe],
})
export class ShimanoTimestampedComponent {
  timestampedData$: Observable<CmsShimanoTimestampedComponent> = this.component.data$;

  constructor(private component: CmsComponentData<CmsShimanoTimestampedComponent>) {}
}
